import Loadable from 'UIComponents/decorators/Loadable';
const AsyncCallTranscriptsUI = Loadable({
  loader: () => import( /* webpackChunkName: "calling-transcript-sidebar" */'transcript-sidebar/components/TranscriptSidebar'),
  LoadingComponent: () => null,
  ErrorComponent: null
});
export default AsyncCallTranscriptsUI;